import axios from "axios";
import { base_url, logout_url, refresh_token } from "./urls";
import { logoutUser, setAccessToken } from "../Redux/Auth";

export const api = axios.create({
  baseURL: base_url,
});

export const apiPublic = axios.create({
  baseURL: base_url,
});

export const setup = (store) => {
  const { dispatch } = store;

  api.interceptors.request.use(
    (config) => {
      const state = store.getState();
      const token = state.auth.accessToken;

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      console.error("Request Error:", error);
      return Promise.reject(error);
    }
  );

  api.interceptors.response?.use(
    (res) => {
      return res;
    },
    async (err) => {
      if (err.response && err.response?.status === 401) {
        try {
          const rs = await apiPublic
            .post(refresh_token, {
              refresh: store.getState().auth.refreshToken,
            })
            .catch(async (error) => {
              if (error?.response && error.response?.status === 401) {
                try {
                  await api.get(logout_url);
                  await dispatch(logoutUser());
                  window.location.href = "/";
                } catch (e) {
                  console.error(e);
                }
                await dispatch(logoutUser());
                return 0;
              }
            });

          const { access } = rs.data;

          dispatch(setAccessToken(access));

          return api(err.config);
        } catch (error) {
          if (error.response && error.response?.status === 401) {
            try {
              await apiPublic.get(logout_url);
              window.location.href = "/";
            } catch (e) {
              console.error(e);
            }
            await dispatch(logoutUser());
            return 0;
          }
          return Promise.reject(error);
        }
      } else if (
        err.response &&
        err.response?.status === 500 &&
        base_url !== "https://api1.tagonstore.com"
      ) {
        const myWindow = window.open("", "response", "resizable=yes");
        myWindow.document.write(err.response?.data);
      }

      return Promise.reject(err);
    }
  );
};
